module.exports = {"SOCIAL_ACCOUNT_CHIP_FOLLOWERS_LABEL":"ผู้ติดตาม"}